import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)]" }
const _hoisted_2 = { class: "fixed top-20 left-0 z-10 bg-white px-6 py-4 shadow-[0_1px_0px_0px_rgba(0,0,0,0.08)] flex justify-between items-center w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Back", -1)
const _hoisted_4 = { class: "w-[92px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Create", -1)
const _hoisted_6 = { class: "mx-6 mt-20 mb-6" }
const _hoisted_7 = {
  key: 0,
  class: "max-w-[500px] mx-auto py-6"
}
const _hoisted_8 = { class: "col-span-2" }
const _hoisted_9 = { class: "flex items-center justify-end w-full space-x-3" }
const _hoisted_10 = { class: "py-6" }
const _hoisted_11 = {
  key: 0,
  class: "border rounded-lg border-neutral-100"
}
const _hoisted_12 = { class: "flex items-center justify-between p-6 border-b tabs border-neutral-100" }
const _hoisted_13 = { class: "flex items-center space-x-4" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-semibold" }, "All Records", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "space-y-5" }
const _hoisted_19 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_20 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_21 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_22 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_23 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_24 = { class: "w-full px-6 border-t py-7" }

import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserLayout from "@/layouts/UserLayout.vue";
import EditButton from "@/components/buttons/EditButton.vue";
import RestoreButton from "@/components/buttons/RestoreButton.vue";
import DeleteButton from "@/components/buttons/DeleteButton.vue";
import DataTable from "@/components/partials/DataTable.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
// import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import TabComponent from "@/components/partials/TabComponent.vue";
import { PlusIcon } from "@heroicons/vue/24/outline";
import InformationFormSection from "./Informations/FormSection.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import TeleCpuLocationService from "@/classes/Settings/TeleCpuLocationService";
import TeleCpuOfficeService from "@/classes/Settings/TeleCpuOfficeService";
import { errorResponse } from "@/helpers/errorMessage";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";

import PageLoader from "@/components/loaders/PageLoader.vue"
import SimplePagination from "@/components/partials/SimplePagination.vue";
import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue"

import { filters, items } from "@/interfaces/pages/FilterPageInterface";
import assignValues from "@/helpers/assignValues"
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const dataroute = useRoute();
const showFilter = ref<boolean>(false);
const loading = ref<boolean>(false);
const offices = ref(null);
const successMessage = ref<string>("Data has been successfully updated!");
const form = ref<{ name: string }>({
	name: "",
});
const tab = ref<any>(route.query.tab);
const datatab = ref<any>(route.query.datatab);
const errors = ref<any>();
const locationId = computed<any>(() => route.params.location);
const filterSearch = ref<any>(route.query.query);
const page = ref<any>(route.query.page);
const lastPage = ref<any>(null);
const rows = ref<any>(route.query.rows || 5);
const numRows = computed(() => (rows.value ? rows.value + " Rows" : "All"));
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const showRestoreConfirmation = ref<boolean>(false);
const showRestoreSuccess = ref<boolean>(false);
const officeId = ref<number>(0);
const filterDate = ref<any>(route.query.date);
const allCount = ref(0)

const tabs = ref<{ name: string; count: number; tab: string; href: string; allowed: boolean }[]>([
	{
		name: "Information",
		count: 0,
		tab: "",
		href: `/settings/telecpu-locations/${locationId.value}/view`,
		allowed: true,
	},
	{
		name: "Offices",
		count: 0,
		tab: "offices",
		href: `/settings/telecpu-locations/${locationId.value}/view?tab=offices`,
		allowed: true,
	},
]);

const dataTabletabs = computed<
	{ name: string; count: number; tab: string; datatab: string | null; allowed: boolean }[]
>(() => [
	{
		name: "All",
		count: offices.value?.allItemsCount,
		tab: "offices",
		datatab: null,
		allowed: true,
	},
	{
		name: "Archived",
		count: offices.value?.archivedItemsCount,
		tab: "offices",
		datatab: "archived",
		
		allowed: true,
	},
	{
		name: "Activity logs",
		count: offices.value?.activityLogsCount,
		tab: "offices",
		datatab: "activity_logs",
		allowed: true,
	},
]);

const headers: { text: string; haveSort?: boolean }[] = [
	{ text: "" },
	{ text: "Offices" },
	{ text: "Date Created", haveSort: true },
];

const save = (): void => {
	TeleCpuLocationService.update(
		{
			location: route.params.location,
		},
		form.value
	)
		.then((response: any) => {
			showConfirmation.value = true;
			successMessage.value = response.data.message;
		})
		.catch((error: any) => (errors.value = errorResponse(error.response?.data?.errors)));
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.replace("/settings/telecpu-locations/index");
};

/**
 * METHODS
 */
const getData = (): void => {
	loading.value = true

	TeleCpuLocationService.edit({location: route.params.location}, pickBy(filters.value))
		.then(({ data }) => {

			form.value.name = data.item.name;
			offices.value = data.offices;
			
			items.value = data.offices.items;
			filters.value = assignValues(filters.value, data.offices);
			loading.value = false
			// dataTabletabs.value[1].count = response.data.archivedItemsCount;
			// dataTabletabs.value[2].count = response.data.activityLogsCount;
		})
		.catch((error: any) => console.log(error));
};

const reloadPage = async () => {
	return await router.push({
		path: `/settings/telecpu-locations/${locationId.value}/view`,
		query: pickBy({
			query: filterSearch.value,
			page: page.value,
			rows: rows.value,
			tab: tab.value,
			datatab: datatab.value,
			date: filterDate.value,
		}),
	});
};

const applyFilters = (search: any = null) => {
	filters.value.query = search;
	showFilter.value = false;

	getData();
};

const applyReset = () => {
	filterDate.value = "";
	reloadPage().then(() => {
		getData();
		showFilter.value = false;
	});
};

const paginate = ({ page, rows }): void => {
	filters.value = Object.assign(filters.value, {
		page, rows
	})
	getData();
};

const updateTab = (currentTab: any) => {

	// const identify = typeof currentTab === "object";
	// tab.value = identify ? currentTab.tab : currentTab;
	filters.value.tab = currentTab;
	filters.value.page = 1;
	// filterSearch.value = "";
	// datatab.value = identify ? currentTab.datatab : "";
	applyFilters();
};

/**
 * MODALS
 */
const showDeleteModal = (item: any): void => {
	showConfirmation.value = true;
	officeId.value = item.id;
};

const closeDeleteModal = (): void => {
	showSuccess.value = false;
};

const deleteRecord = (): void => {
	TeleCpuOfficeService.delete({
		location: locationId.value,
		telcpu: officeId.value,
	})
		.then(() => {
			showSuccess.value = true;
			showConfirmation.value = false;
			applyFilters();
		})
		.catch((error) => console.log(error));
};

const showRestoreModal = (item: any): void => {
	showRestoreConfirmation.value = true;
	officeId.value = item.id;
};

const closeRestoreModal = (): void => {
	showRestoreSuccess.value = false;
};

const restoreRecord = (): void => {
	TeleCpuOfficeService.restore({
		location: locationId.value,
		telcpu: officeId.value,
	})
		.then(() => {
			showRestoreSuccess.value = true;
			showRestoreConfirmation.value = false;
			applyFilters();
		})
		.catch((error) => console.log(error));
};

/**
 * WATCHERS
 */
watch(
	filterSearch,
	throttle((val: string) => {
        filters.value.page = 1;
		applyFilters(val);
	}, 1000)
);

onMounted(() => {
	getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace('/settings/telecpu-locations/index')))
          }, [
            _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition" }, {
              default: _withCtx(() => [
                _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _createVNode(TabComponent, { tabs: tabs.value }, null, 8, ["tabs"]),
          _createElementVNode("div", _hoisted_4, [
            (_unref(route).query.tab === 'offices')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).replace(`/settings/telecpu-locations/${locationId.value}/office/create`)))
                }, [
                  _createVNode(ButtonComponent, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_unref(route).query.tab != 'offices')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(InformationFormSection, {
                  form: form.value,
                  errors: errors.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("a", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).replace(`/settings/telecpu-locations/index`)))
                        }, [
                          _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Cancel")
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(ButtonComponent, {
                          btnWidth: "primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (save()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Save Changes")
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(ConfirmationModal, {
                        typeTwo: true,
                        show: showConfirmation.value,
                        onCancel: _cache[4] || (_cache[4] = ($event: any) => (showConfirmation.value = false)),
                        onConfirm: _cache[5] || (_cache[5] = ($event: any) => {
									showSuccess.value = true;
									showConfirmation.value = false;
								}),
                        "cancel-text": "Cancel",
                        "action-text": "Confirm",
                        title: "Update Record",
                        content: "Are you sure you wish to update this record?"
                      }, null, 8, ["show"]),
                      _createVNode(SuccessModal, {
                        show: showSuccess.value,
                        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (redirectSuccess())),
                        "action-text": "Close",
                        title: "Record Updated!",
                        content: successMessage.value
                      }, null, 8, ["show", "content"])
                    ])
                  ]),
                  _: 1
                }, 8, ["form", "errors"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (_unref(route).query.tab === 'offices')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(TabComponent, {
                        tabs: dataTabletabs.value,
                        "return-object": true,
                        "onUpdate:tab": _cache[7] || (_cache[7] = (value) => updateTab(value.datatab))
                      }, null, 8, ["tabs"])
                    ])
                  ]),
                  (_unref(filters).tab != 'activity_logs')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(DataTable, {
                          hasSearch: true,
                          searchPlaceholder: "Search center",
                          dataTableClass: "border-0",
                          headers: headers,
                          "no-action": false,
                          count: _unref(items).total,
                          "onUpdate:searchText": _cache[19] || (_cache[19] = (value) => (filterSearch.value = value)),
                          tableClass: "header-frm-table"
                        }, {
                          topContent: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "flex items-center px-3 py-2 space-x-1 border border-solid rounded border-neutral-100 hover:bg-primary-100 transition w-max",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (showFilter.value = true))
                              }, _hoisted_17),
                              _createVNode(FilterPanel, {
                                show: showFilter.value,
                                onClose: _cache[10] || (_cache[10] = ($event: any) => (showFilter.value = false)),
                                "onApply:reset": _cache[11] || (_cache[11] = ($event: any) => (applyReset())),
                                "onApply:filters": _cache[12] || (_cache[12] = ($event: any) => (applyFilters()))
                              }, {
                                fields: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(DatePicker, {
                                      id: "date_created",
                                      name: "date_created",
                                      label: "Date Created",
                                      range: true,
                                      modelValue: filterDate.value,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filterDate).value = $event))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["show"])
                            ])
                          ]),
                          body: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data, (item) => {
                              return (_openBlock(), _createElementBlock("tr", { key: item }, [
                                _createElementVNode("td", _hoisted_19, _toDisplayString(item.id), 1),
                                _createElementVNode("td", _hoisted_20, _toDisplayString(item.name), 1),
                                _createElementVNode("td", _hoisted_21, _toDisplayString(item.created_at_formatted), 1),
                                _createElementVNode("td", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    (!_unref(filters).tab)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createVNode(EditButton, {
                                            onClick: ($event: any) => (
																_unref(router).replace(
																	`/settings/telecpu-locations/${locationId.value}/office/${item.id}/edit`
																)
															)
                                          }, null, 8, ["onClick"]),
                                          _createVNode(DeleteButton, {
                                            onClick: ($event: any) => (showDeleteModal(item))
                                          }, null, 8, ["onClick"])
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (_unref(filters).tab == 'archived')
                                      ? (_openBlock(), _createBlock(RestoreButton, {
                                          key: 1,
                                          onClick: ($event: any) => (showRestoreModal(item))
                                        }, null, 8, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]),
                          tfoot: _withCtx(() => [
                            _createVNode(ConfirmationModal, {
                              typeTwo: true,
                              show: showConfirmation.value,
                              onCancel: _cache[13] || (_cache[13] = ($event: any) => (showConfirmation.value = false)),
                              onConfirm: _cache[14] || (_cache[14] = ($event: any) => (deleteRecord())),
                              "cancel-text": "Cancel",
                              "action-text": "Confirm",
                              title: "Delete Record",
                              content: "Are you sure you wish to delete this record?"
                            }, null, 8, ["show"]),
                            _createVNode(SuccessModal, {
                              show: showSuccess.value,
                              onConfirm: _cache[15] || (_cache[15] = ($event: any) => (closeDeleteModal())),
                              "action-text": "Close",
                              title: "Record Deleted!",
                              content: "Selected record has been successfully deleted!"
                            }, null, 8, ["show"]),
                            _createVNode(ConfirmationModal, {
                              typeTwo: true,
                              show: showRestoreConfirmation.value,
                              onCancel: _cache[16] || (_cache[16] = ($event: any) => (showRestoreConfirmation.value = false)),
                              onConfirm: _cache[17] || (_cache[17] = ($event: any) => (restoreRecord())),
                              "cancel-text": "Cancel",
                              "action-text": "Confirm",
                              title: "Restore Record",
                              content: "Are you sure you wish to restore this record?"
                            }, null, 8, ["show"]),
                            _createVNode(SuccessModal, {
                              show: showRestoreSuccess.value,
                              onConfirm: _cache[18] || (_cache[18] = ($event: any) => (closeRestoreModal())),
                              "action-text": "Close",
                              title: "Record Restored!",
                              content: "Selected record has been successfully restored!"
                            }, null, 8, ["show"])
                          ]),
                          _: 1
                        }, 8, ["count"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(filters).tab == 'activity_logs')
                    ? (_openBlock(), _createBlock(ActivityLogsTable, {
                        key: 1,
                        items: _unref(items)
                      }, null, 8, ["items"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(SimplePagination, {
                      numRows: _unref(filters).rows,
                      currentPage: _unref(items).current_page,
                      "last-page": _unref(items).last_page,
                      onUpdate: _cache[20] || (_cache[20] = (value) => paginate(value))
                    }, null, 8, ["numRows", "currentPage", "last-page"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})